const DIGITS_MATCH = /^$|^(\+)|(\d+)/g;
const cleanNumber = number => number.match(DIGITS_MATCH)?.join('') ?? '';

export { cleanNumber };
//# sourceMappingURL=cleanNumber.mjs.map
